var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:!_vm.text ? 'text-muted' : ''},[_vm._v(" "+_vm._s(_vm.text || 'Sin definir')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }